import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  flexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  container: {
    backgroundColor: theme.palette.common.white,
    margin: '0 0 24px 0',
    borderRadius: 18,
    border: '1px solid rgba(16,24,40,0.07)',
    boxShadow:
      'inset 0 1px 0 rgba(255,255,255,0.9), 0 1px 2px rgba(16,24,40,0.06), 0 10px 28px -12px rgba(16,24,40,0.18)',
    backgroundImage: 'linear-gradient(180deg, #FFFFFF 0%, #FBFBFC 100%)',
    textAlign: 'left',
    overflow: 'hidden',
    paddingBottom: 0
  },
  heading: {
    backgroundColor: theme.palette.common.white,
    backgroundImage:
      'linear-gradient(180deg, rgba(255,241,233,0.75) 0%, rgba(255,255,255,0) 100%)',
    width: '100%',
    padding: '16px 24px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderRadius: '16px 16px 0 0',
    textAlign: 'left'
  },
  heading2: {
    backgroundColor: theme.palette.common.white,
    backgroundImage:
      'linear-gradient(180deg, rgba(255,241,233,0.75) 0%, rgba(255,255,255,0) 100%)',
    width: '100%',
    padding: '16px 24px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderRadius: '16px 16px 0 0',
    textAlign: 'left'
  },
  headingBlack: {
    backgroundColor: theme.palette.common.white,
    backgroundImage:
      'linear-gradient(180deg, rgba(255,241,233,0.75) 0%, rgba(255,255,255,0) 100%)',
    width: '100%',
    padding: '16px 24px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderRadius: '16px 16px 0 0',
    textAlign: 'left'
  },
  text: {
    color: theme.palette.text.primary,
    fontSize: 16,
    fontWeight: 700
  },
  textWhite: {
    color: theme.palette.text.primary,
    fontSize: 16,
    fontWeight: 700
  },
  form: {
    margin: '4px 24px 24px 24px',
    alignItems: 'stretch',
    textAlign: 'left'
  },
  labelText: {
    textAlign: 'left',
    marginLeft: 0,
    fontSize: '13px',
    fontWeight: 600,
    color: theme.palette.text.disabled,
    marginTop: '16px'
  },
  fileUpload: {
    marginTop: 10,
    backgroundColor: theme.palette.primary.main,
    display: 'inline-block',
    padding: '8px 14px',
    cursor: 'pointer',
    color: theme.palette.common.white,
    borderRadius: 10,
    fontWeight: 600,
    fontSize: 13
  },
  file: {
    display: 'none'
  },
  image: {
    width: 72,
    height: 72,
    objectFit: 'cover',
    borderRadius: 12,
    border: '1px solid #E0E0E0'
  }
}))

export default useStyles
